import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";

import { v4 as uuidv4 } from "uuid";

import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import { puede } from "../../../../permisos/permisos";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function DevolucionesProveedoresCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_COMPRAS = process.env.REACT_APP_URL_COMPRAS;
  const URL_DEVOLUCIONES_PROVEEDORES = process.env.REACT_APP_URL_DEVOLUCIONES_PROVEEDORES;

  const URL_INVENTARIOS_TELAS = process.env.REACT_APP_URL_INVENTARIOS_TELAS;
  const URL_TELAS_DEVOLUCIONES_PROVEEDORES =
    process.env.REACT_APP_URL_TELAS_DEVOLUCIONES_PROVEEDORES;

  const URL_DEVOLUCIONES_PROVEEDORES_ACUMULADOS =
    process.env.REACT_APP_URL_DEVOLUCIONES_PROVEEDORES_ACUMULADOS;

    let date = new Date();
    let hoy = moment(date).format("YYYY-MM-DD");

  const [compras, setCompras] = useState([]);
  const [selectedCompra, setSelectedCompra] = useState("");

  const [proveedor, setProveedor] = useState("");
  const [idProveedor, setIdProveedor] = useState("");
  const [fecha, setFecha] = useState(hoy);
  const [fecha_compromiso, setFechaCompromiso] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [total_kilos, setTotalKilos] = useState(0);
  const [total_metros, setTotalMetros] = useState(0);
  const [total_general, setTotalGeneral] = useState(0);
  const [iva, setIva] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [impuestos, setImpuestos] = useState(0);


  const [telasDevolucion, setTelasDevolucion] = useState([]);
  const [fecha_compra, setFechaCompra] = useState("");
  const [proveedorPedido, setProveedorPedido] = useState("");
  const [total_kilos_pedido, setTotalKilosPedido] = useState(0);
  const [total_metros_pedido, setTotalMetrosPedido] = useState(0);
  const [total_general_pedido, setTotalGeneralPedido] = useState(0);

  const [idsInventarioTelas, setIdsInventarioTelas] = useState([]);
  const [cantidadAgrupado, setCantidadAgrupado] = useState([]);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const classes = useStyles();
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      idInventarioTelas: "",
      telas: "",
      idTela: "",
      unidad: "",
      colores: "",
      cantidad: 0,
      costo:0
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios
      .get(URL_COMPRAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allCompras = res.data;
        setCompras(allCompras);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);


  const saveDevolucion = async (event) => {
    event.preventDefault();
    setValidaBoton(false);
    toggleProgreso();


    let totalRollos =
      inputFields.length + cantidadAgrupado.length

    try {
      await axios
        .post(
          URL_DEVOLUCIONES_PROVEEDORES,
          {
            fecha,
            compras: selectedCompra,
            user: user.id,
            observaciones,
            subTotal:subTotal.toFixed(2),
            iva: iva.toFixed(2),
            total_general: total_general.toFixed(2),
            total_cantidad: parseFloat(total_metros) + parseFloat(total_kilos),
            aplicada:"No",
            proveedores:idProveedor
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then((data) => {
          inputFields.map((a) => {
            if (a.telas != "") {
              axios
                .patch(
                  `${URL_INVENTARIOS_TELAS}/devolucionProveedores/${a.idInventarioTelas}`,
                  {
                    devolucionesProveedores: data.data._id,
                    is_active:"No"
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        "app_token"
                      )}`,
                    },
                  }
                )
                .then(() => {
                  totalRollos = totalRollos - 1;
                  if (totalRollos == 0) {
                    axios
                      .post(
                        URL_LOGS,
                        {
                          tipo: "Crear Devolucion",
                          detalle: `Compra ${selectedCompra}`,
                          user: user.id,
                        },
                        {
                          headers: {
                            Authorization: `Bearer: ${localStorage.getItem(
                              "app_token"
                            )}`,
                          },
                        }
                      )
                      .then(() => {
                        Swal.fire("Good job!", "Creado con exito", "success");
                        setTimeout(() => {
                          window.location.reload();
                        }, 1000);
                      })
                      .catch((error) => {
                        Swal.fire({
                          icon: "error",
                          title: "Oops...",
                          text: "Something went wrong!",
                          footer: `${error.response.data}`,
                        });
                        console.log(error);
                        setValidaBoton(true);
                      });
                  }
                });
            } else {
              totalRollos = totalRollos - 1;
              if (totalRollos == 0) {
                axios
                  .post(
                    URL_LOGS,
                    {
                      tipo: "Crear Devolucion",
                      detalle: `Compra ${selectedCompra}`,
                      user: user.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then(() => {
                    Swal.fire("Good job!", "Creado con exito", "success");
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                      footer: `${error.response.data}`,
                    });
                    console.log(error);
                    setValidaBoton(true);
                  });
              }
            }
          });

          
          // Pegamos a Devoluciones Acumulado

          cantidadAgrupado.map((w) => {
            axios
              .post(
                `${URL_DEVOLUCIONES_PROVEEDORES_ACUMULADOS}`,
                {
                  devolucionesProveedores: data.data._id,
                  telas: w.idTela,
                  colores: w.colores,
                  cantidad: w.cantidad,
                  fecha,
                  proveedores: idProveedor,
                  compras: selectedCompra,
                  costo:w.costo
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(() => {
                totalRollos = totalRollos - 1;
                if (totalRollos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Crear Devolucion",
                        detalle: `Compra ${selectedCompra}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      Swal.fire("Good job!", "Creado con exito", "success");
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          });

          // Terminamos de post a devoluciones acumulado
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
      console.log(error);
    }
  };

  const handleAddFields = () => {
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        idInventarioTelas: "",
        telas: "",
        idTela: "",
        unidad: "",
        colores: "",
        cantidad: 0,
        costo:0
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let mts = values.filter((e) => e.unidad == "Metros");
    let totalMts = mts.map((c) => parseFloat(c.cantidad));
    let TM = totalMts.reduce((t, total, index) => t + total, 0);
    setTotalMetros(TM);
    let KG = values.filter((e) => e.unidad == "Kilos");
    let totalKG = KG.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalKilos(TK);

    let totalDin = values.map((c) => parseFloat(c.costo));
    let TDin = totalDin.reduce((t, total, index) => t + total, 0);
    setTotalGeneral(TDin);
  };

  function BuscaTela(id, event) {
    if (event.target.value.length >= 24) {
      if (idsInventarioTelas.includes(event.target.value)) {
        if (
          inputFields.filter((e) => e.idInventarioTelas == event.target.value)
            .length > 0
        ) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "El rollo ya fue escaneado!",
            showConfirmButton: false,
          });
          const newInputFields = inputFields.map((i) => {
            if (id === i.id) {
              i.idInventarioTelas = "";
            }
            return i;
          });
          setInputFields(newInputFields);
        } else {
          telasDevolucion.map((a) => {
            if (a._id == event.target.value) {
              let telasDevolucion = a._id;
              let tela = a.tela;
              let idTela = a.idTela;
              let unidadTela = a.unidadTela;
              let color = a.color;
              let cantidad = a.cantidad;
              let costo = a.costo
              handleChangeInputTela(
                id,
                telasDevolucion,
                tela,
                idTela,
                unidadTela,
                color,
                cantidad,
                costo
              );
            }
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "El rollo no pertenece a la compra o fue devuelto previamente!",
          showConfirmButton: false,
        });
        const newInputFields = inputFields.map((i) => {
          if (id === i.id) {
            i.idInventarioTelas = "";
          }
          return i;
        });
        setInputFields(newInputFields);
      }
    } else {
      const newInputFields = inputFields.map((i) => {
        if (id === i.id) {
          i.idInventarioTelas = event.target.value;
        }
        return i;
      });
      setInputFields(newInputFields);
    }
  }

  const handleChangeInputTela = (
    id,
    telasDevolucion,
    tela,
    idTela,
    unidadTela,
    color,
    cantidad,
    costo
  ) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.idInventarioTelas = telasDevolucion;
        i.telas = tela;
        i.idTela = idTela;
        i.unidad = unidadTela;
        i.colores = color;
        i.cantidad = cantidad;
        i.costo = costo
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
    handleAddFields();
  };

  function ActualizaTotales() {
    let mts = inputFields.filter((e) => e.unidad == "Metros");
    let totalMts = mts.map((c) => parseFloat(c.cantidad));
    let TM = totalMts.reduce((t, total, index) => t + total, 0);
    setTotalMetros(TM);
    let KG = inputFields.filter((e) => e.unidad == "Kilos");
    let totalKG = KG.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalKilos(TK);

    let totalDinero = inputFields.map((c) => parseFloat(c.costo));
    let dinero = totalDinero.reduce((t, total, index) => t + total, 0);
    setSubTotal(dinero);

    if (impuestos != 0) {
      setIva((impuestos * dinero) / 100);
    } else {
      setIva(0);
    }
    let totTemp = (impuestos * dinero) / 100 + dinero;

    setTotalGeneral(totTemp);

    let agrupado = inputFields.reduce(function (groups, item) {
      const val = item["idTela"] + item["colores"]
      groups[val] = groups[val] || {
        idTela: item.idTela,
        colores: item.colores,
        cantidad: 0,
        costo:0
      };
      groups[val].cantidad += item.cantidad;
      groups[val].costo += item.costo;
      groups[val].id = item.id;
      groups[val].idInventarioTelas = item.idInventarioTelas;
      groups[val].telas = item.telas;
      groups[val].idTela = item.idTela;
      groups[val].unidad = item.unidad;
      groups[val].colores = item.colores;
      return groups;
    }, []);

    let CA = Object.values(agrupado);
    setCantidadAgrupado(CA);
  }


  function jalaCompra(e) {
    setSelectedCompra(e);

    axios
      .get(`${URL_INVENTARIOS_TELAS}/comprasDevolucion/${e}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allTelasDevolucion = res.data;
        setTelasDevolucion(allTelasDevolucion);
        let result = allTelasDevolucion.map(({ _id }) => _id);
        setIdsInventarioTelas(result);
      })
      .catch((err) => {
        console.log(err);
      });



    compras.map((a) => {
      if (a._id == e) {
        setFechaCompra(a.fecha);
        setTotalKilosPedido(a.total_kilos);
        setTotalMetrosPedido(a.total_metros);
        setTotalGeneralPedido(a.total_general);
        setProveedor(a.ordenesCompra[0].proveedores[0].razon_social);
        setIdProveedor(a.ordenesCompra[0].proveedores[0]._id);
        if(a.iva > 0){
          setImpuestos(16)
        }

      }
    });
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {puede(user, "compras.devoluciones.crear") ? (
        <div className="card container col-10">
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <i className="fas fa-undo-alt" style={{ marginRight: 8, color: "#ef4444" }} />
                Nueva Devolucion Tela
              </h3>
              <p className="page-subtitle">Registra una devolución de tela a proveedor</p>
            </div>
          </div>
          <Form>

          <div className="form-section">
            <div className="form-section-header">
              <i className="fas fa-info-circle" />
              <span className="form-section-title">Datos Generales</span>
            </div>
            <div className="form-section-body">
            <Row>
              <Col md={3}>
                <Label className="mr-sm-2">Compra</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedCompra}
                  required
                  onChange={(e) => jalaCompra(e.target.value)}
                >
                  <option value="0">Selecciona un Compra</option>
                  {compras
                    .sort((a, b) => (a.idCompras < b.idCompras ? 1 : -1))
                    .map((a) => {
                      if(a.ordenesCompra[0].tipo == "Tela")
                      return (
                        <option value={a._id}>
                          # {a.idCompras}{" / "}
                          {a.ordenesCompra[0].proveedores[0].nombre_comercial}
                        </option>
                      );
                    })}
                </Input>
              </Col>
              <Col md={3}>
                <Label>Fecha Compra</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha_compra}
                  required
                  disabled
                  onChange={(e) => {
                    setFechaCompra(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Proveedor</Label>
                <Input
                  type="text"
                  placeholder="Proveedor"
                  value={proveedor}
                  required
                  disabled
                  onChange={(e) => {
                    setProveedor(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={3}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha}
                  required
                  onChange={(e) => {
                    setFecha(e.target.value);
                  }}
                />
              </Col>
              <Col md={6}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <h4 id="logoutBoton">
                  TOTALES {new Intl.NumberFormat("en-US").format(total_kilos)}{" "}
                  kg. / {new Intl.NumberFormat("en-US").format(total_metros)}{" "}
                  mts.
                </h4>
              </Col>
            </Row>
            </div>
          </div>

            {/* Tabla Telas */}

          <div className="form-section">
            <div className="form-section-header">
              <i className="fas fa-list" />
              <span className="form-section-title">Telas</span>
            </div>
            <div className="form-section-body">

            <Row>
              <Col md={3}>
                <Label className="mr-sm-2">Codigo</Label>
              </Col>
              <Col md={4}>
                <Label className="mr-sm-2">Telas</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Unidad</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
            </Row>

            {inputFields.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={3}>
                    <Input
                      bsSize="sm"
                      name="idInventarioTelas"
                      type="string"
                      value={inputField.idInventarioTelas}
                      onChange={(event) => {
                        BuscaTela(inputField.id, event);
                      }}
                    ></Input>
                  </Col>
                  <Col md={4}>
                    <Input
                      bsSize="sm"
                      name="telas"
                      type="string"
                      value={inputField.telas}
                      disabled
                    ></Input>
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="unidad"
                      type="string"
                      value={inputField.unidad}
                      disabled
                    ></Input>
                  </Col>

                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="cantidad"
                      type="string"
                      value={inputField.cantidad}
                      disabled
                    ></Input>
                  </Col>

                  <Col>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemoveFields(inputField.id)}
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFields}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>
              </div>
            ))}
            <Row>
              <Col md={12}>
                <h4 id="logoutBoton">
                  TOTALES {new Intl.NumberFormat("en-US").format(total_kilos)}{" "}
                  kg. / {new Intl.NumberFormat("en-US").format(total_metros)}{" "}
                  mts.
                </h4>
              </Col>
            </Row>
            {/* Termina Tabla Telas */}
            </div>
          </div>

            <br />
          </Form>
          <div className="submit-bar">
              <Button
                href="/ListadoDevolucionesProveedores"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
              {validaBoton ? (
                <Button
                  type="submit"
                  className="btn btn-success"
                  onClick={saveDevolucion}
                >
                  <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
                </Button>
              ) : (
                <Button type="submit" className="btn btn-success" disabled>
                  <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
                </Button>
              )}
          </div>
          <br />
           <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
             <h4> Este proceso puede tardar varios minutos.
              <br />
              Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default DevolucionesProveedoresCreate;
